import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const categoryListSelector = createSelector(
  (state: RootState) => state.privateBlog.categoryItems,
  (categoryItems) => {
    if (categoryItems) {
      return Object.keys(categoryItems).map((v) => categoryItems[v].category);
    }
    return [];
  },
);

export const categoryListLengthSelector = createSelector(
  (state: RootState) => state.privateBlog.categoryItems,
  (categoryItems) => {
    if (categoryItems) {
      return Object.keys(categoryItems).length;
    }
    return 0;
  },
);

export const isInitCategoryItemsSelector = createSelector(
  (state: RootState) => state.privateBlog.categoryItems,
  (categoryItems) => categoryItems !== undefined,
);

export const categoryItemsSelector = createSelector(
  (state: RootState) => state.privateBlog.categoryItems,
  (categoryItems) => categoryItems,
);

export const contentSelector = createSelector(
  (state: RootState) => state.privateBlog.content?.item,
  (content) => content,
);

export const nurseryIdSelector = createSelector(
  (state: RootState) => ({
    facilityList: state.childApply.facilityList,
    childId: state.child.childId,
  }),
  ({ facilityList, childId }) => {
    const facility = facilityList.find((v) => v.data.childId === childId);
    return facility?.data.facilityId || '';
  },
);
